import React from "react";
import Body from "./Body";
import altImg from "../../../../assets/Images/finance/AcademicEx/exam-material.png";

const ResidentialEx = () => {
  const ResidentialEx = [
    // {
    //   title: "Salaries",
    //   description:
    //     "You can collect salaries of academic contributors (Teachers, Non-teaching staffs, and other officials).",
    //   link: "salaries",
    //   image: altImg,
    // },
    {
      title: "Food And Dining",
      description:
        "Food and dining equipment and daily meal cost are recorded here.",
      link: "food-and-dining",
      image: altImg,
    },
    {
      title: "Accomodation",
      description:
        "Manages hostel living, repairs, utilities, and related services.",
      link: "accommodation-maintenance",
      image: altImg,
    },
    {
      title: "Electric Billing",
      description:
        "Easily track, calculate, and pay monthly electricity bills for hostel rooms through the resident management system.",
      link: "electric-billing",
      image: altImg,
    },
    {
      title: "Cleaning and sanitation",
      description: "Manage hostel cleaning, sanitation, and related expenses.",
      link: "cleaning-and-sanitation",
      image: altImg,
    },
    {
      title: "Other Maintenance",
      description:
        "Hostel upgradation, tenders, workshops, and maintenance activities.",
      link: "other-mainteneance",
      image: altImg,
    },
  ];
  const _this = { ResidentialEx };
  return <Body {..._this} />;
};

export default ResidentialEx;
